import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  button: {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.grey[300]}`,
    color: colors.black,
    fontSize: 18,
    fontWeight: 600,
    padding: theme.spacing(1, 2),
    textDecoration: "none",
    "&:hover": {
      color: colors.black,
      textDecoration: "none",
    },
  },
  buttonIcon: {
    marginLeft: theme.spacing(1),
  },
  popover: {
    padding: 0,
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 0,
    boxShadow: `0 8px 16px 0 ${theme.palette.grey[200]}`,
    minWidth: 468,
  },
}));

export default useStyles;
